// This file defines the style for "Full Screen Form" buttons.

import {
  Platform,
  StyleSheet,
} from 'react-native';

import {
  primaryColor,
  primaryColorWithOpacity,
  primaryFont700,
} from './Common';

// const imageWidth = '80%';

export default StyleSheet.create({
  secondaryContainer: {
    ...(Platform.OS === 'web' ? ({
      width: '80%',
    }) : ({
      width: '100%',
      paddingHorizontal: 10,
    })),
  },
  secondaryTitle: {
    color: primaryColor,
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  secondary: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColorWithOpacity,
    borderColor: primaryColor,
    borderRadius: 8,
    marginVertical: 10,
  },
  secondaryTitleDisabled: {
    color: 'black',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  secondaryDisabled: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColorWithOpacity,
    borderColor: primaryColor,
    borderRadius: 8,
    marginVertical: 10,
    opacity: 0.3,
  },
  primaryContainer: {
    // width: imageWidth,
    ...(Platform.OS === 'web' ? ({
      width: '80%',
    }) : ({
      width: '100%',
      paddingHorizontal: 10,
    })),
  },
  primaryTitle: {
    color: 'white',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  primary: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 8,
    marginVertical: 10,
  },
  primaryTitleDisabled: {
    color: 'black',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  primaryDisabled: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 8,
    marginVertical: 10,
    opacity: 0.3,
  },
});
